import { createBrowserRouter, RouterProvider } from "react-router-dom";
import PageHome from "./Views/PageHome";
import Ifram from "./Views/Ifrme";

const router = createBrowserRouter([
  {
    path: "/",
    element: <PageHome />,
  },
  {
    path: "/stream/:idsw",
    element: <Ifram/>,
  },
]);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
